import i18n from 'i18next';
import * as yup from 'yup';

import { URL_REGEX } from '@/config/variables';
import { AnnouncementType } from '@/store/enums';

export const linkEditSchema = yup.object().shape({
  folder: yup.string().required(i18n.t('common.labelThisFieldIsRequired')),
  name: yup.string().trim().required(i18n.t('common.labelThisFieldIsRequired')),
  url: yup
    .string()
    .matches(URL_REGEX, i18n.t('common.labelInvalidFormat'))
    .required(i18n.t('common.labelThisFieldIsRequired')),
  description: yup.string(),
  startDate: yup.string().required(i18n.t('common.labelThisFieldIsRequired')),
  startTime: yup.string().required(i18n.t('common.labelThisFieldIsRequired')),
  endDate: yup.string(),
  endTime: yup.string(),
  visibility: yup
    .string()
    .matches(/(Client|Agent|Both)/)
    .required(i18n.t('common.labelThisFieldIsRequired')),
});

export const announcementEditSchema = yup.object().shape({
  folder: yup.string().required(i18n.t('common.labelThisFieldIsRequired')),
  title: yup.string().trim().required(i18n.t('common.labelThisFieldIsRequired')),
  body: yup.string(),
  startDate: yup.string().required(i18n.t('common.labelThisFieldIsRequired')),
  startTime: yup.string().required(i18n.t('common.labelThisFieldIsRequired')),
  endDate: yup.string(),
  endTime: yup.string(),
  stayOnTop: yup.boolean(),
  notify: yup.boolean(),
  everyone: yup.boolean(),
  attachments: yup.array(),
  type: yup
    .mixed<AnnouncementType>()
    .transform(Number)
    .oneOf(Object.values(AnnouncementType) as number[]),
  recipients: yup.array().when(['notify', 'everyone'], {
    is: (notify: boolean, everyone: boolean) => notify && !everyone,
    then: yup.array().min(1, i18n.t('common.labelThisFieldIsRequired')),
  }),
  countries: yup.array(),
});

export const documentEditSchema = yup.object().shape({
  folder: yup.string().required(i18n.t('common.labelThisFieldIsRequired')),
  name: yup.string().trim().required(i18n.t('common.labelThisFieldIsRequired')),
  description: yup.string(),
  startDate: yup.string().required(i18n.t('common.labelThisFieldIsRequired')),
  startTime: yup.string().required(i18n.t('common.labelThisFieldIsRequired')),
  endDate: yup.string(),
  endTime: yup.string(),
  file: yup.array().min(1, i18n.t('common.labelThisFieldIsRequired')),
});

export const folderEditSchema = yup.object().shape({
  name: yup.string().trim().required(i18n.t('common.labelThisFieldIsRequired')),
});
